<template>
  <b-container>
    <b-row class="mt-3 justify-content-center">
      <b-alert show variant="success" class="text-center">
        <h3>
          {{ $t('PaymentSuccess.headerMsg') }}
          <font-awesome-icon icon="check-circle" />
        </h3>
        <p>{{ $t('PaymentSuccess.mainMsg') }}</p>
      </b-alert>
    </b-row>

    <hr />
    <div class="text-left">
      <h5>
        {{ $t('PaymentSuccess.confirmationNumber') }}:
        <span
          style="color: #155724;"
        >{{orderinfo.orderConfId}}</span>
      </h5>
      <h5>{{ orderinfo.name }}</h5>
      <h5 v-if="orderinfo.brand">({{orderinfo.brand}}&nbsp;...{{orderinfo.last4}})</h5>
    </div>

    <div class="text-right">
      <b-table responsive borderless :fields="fields" :items="items" thead-class="text-right">
        <template v-slot:cell(namevariant)="data">
          <div class="text-left">
            <b>{{data.item.name}} {{data.item.variant}}</b>
            <span v-if="data.item.style">{{data.item.style}}</span>
            <span v-if="data.item.style && data.item.extras.length > 0">/</span>
            <span v-if="data.item.extras.length > 0">{{data.item.extras.join(', ')}}</span>
          </div>
        </template>
        <template
          v-slot:cell(pricecurrency)="data"
        >{{data.item.price.toFixed(2)}} {{data.item.currency ? data.item.currency.toUpperCase() : null}}</template>
      </b-table>
      <i>VAT 7.7% (incl.) = {{(orderinfo.amount * 0.077).toFixed(2) }} {{orderinfo.currency ? orderinfo.currency.toUpperCase() : null}}</i>
      <br />
      <b>Total:</b>
      {{orderinfo.amount.toFixed(2)}} {{orderinfo.currency ? orderinfo.currency.toUpperCase() : null}}
    </div>

    <b-row align-v="end" class="text-right" v-if="!orderinfo.brand">
      <b-col>
        <h5 style="color: #721c24;">{{ $t('PaymentSuccess.payment') }}</h5>
      </b-col>
    </b-row>

    <hr />
    <b-form inline class="justify-content-center mt-4">
      <b-input
        id="inline-form-input-email"
        class="mb-2 mr-sm-2 mb-sm-0"
        :placeholder="$t('PaymentSuccess.emailPlaceholder')"
        v-model="email"
        required
      ></b-input>
      <b-button
        @click="emailConfirmation"
        variant="danger"
      >{{ $t('PaymentSuccess.emailOrderConf') }}</b-button>
    </b-form>

    <b-row class="mt-3 justify-content-center">
      <b-alert :show="error.received" variant="danger" class="text-center" dismissible>{{error.msg}}</b-alert>
      <b-alert
        :show="success.received"
        variant="success"
        class="text-center"
        dismissible
      >{{success.msg}}</b-alert>
    </b-row>

    <b-row class="justify-content-center mt-3">
      <router-link :to="{name: 'Home'}">{{ $t('PaymentSuccess.homePageLink') }}</router-link>
    </b-row>
  </b-container>
</template>

<script>
import MailService from '@/services/MailService'

export default {
  name: 'PaymentSuccess',
  data () {
    return {
      orderinfo: this.$route.params.orderinfo.data.orderinfo,
      items: [],
      email: '',
      fields: [
        {
          key: 'namevariant',
          label: ''
        },
        {
          key: 'quantity',
          label: this.$i18n.t('PaymentSuccess.quantity')
        },
        {
          key: 'pricecurrency',
          label: this.$i18n.t('PaymentSuccess.price')
        }
      ],
      error: {
        received: false,
        msg: ''
      },
      success: {
        received: false,
        msg: ''
      }
    }
  },
  mounted () {
    // redirect to home if orderinfo is empty
    if (!this.orderinfo) this.$router.push({ name: 'Home' })

    this.buildTable()
  },
  methods: {
    buildTable () {
      this.items = this.$route.params.orderinfo.data.orderinfo.items
    },
    async emailConfirmation () {
      this.orderinfo.email = this.email
      this.orderinfo.lang = this.$i18n.locale

      try {
        // send confirmation email
        await MailService.orderConf(this.orderinfo)

        // reset email field
        this.email = ''

        // show message
        this.success.received = true
        this.success.msg = this.$i18n.t(
          'PaymentSuccess.serverMessages.confirmationSent'
        )
      } catch (error) {
        if (error.response.data.error === 'invalidEmailAddress') {
          this.error.received = true
          this.error.msg = this.$i18n.t(
            'PaymentSuccess.serverMessages.invalidEmailAddress'
          )
        } else {
          this.error.received = true
          this.error.msg = this.$i18n.t(
            'PaymentSuccess.serverMessages.generic'
          )
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PaymentSuccess.vue